import { render, staticRenderFns } from "./EditBusinessInfo.vue?vue&type=template&id=019bbb84&scoped=true&"
import script from "./EditBusinessInfo.vue?vue&type=script&lang=js&"
export * from "./EditBusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditBusinessInfo.vue?vue&type=style&index=0&id=019bbb84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bbb84",
  null
  
)

export default component.exports